import { useStore } from '../state/ui-store';

export const hideParticles = () => {
  const { visibilityFuncs } = useStore.getState();
  visibilityFuncs.fluid(0);
};
